import { Button } from "@mui/material";
import React, { useContext, useState } from "react";
import globalContext from '../../context/context'
import { CssTextField } from "../../utils/CssTextField";
import { useTranslation } from "react-i18next";

function LoginComponent() {

    const { t } = useTranslation();
    const { login, setSnack } = useContext(globalContext);

    const [username, setUsername] = useState('');
    const [pass, setPass] = useState('');

    const handleLogin = () => {


        let errors = '';

        if (!username || !pass) {
            errors = t("LoginComponent.everyField")
        } 

        if(errors){
            setSnack({
                message: errors,
                severity: 'error',
                open: true
            })
        } else{
            login(username, pass)
        }

    }



    return (
        <>
            <CssTextField size="small"
                value={username}
                name="username"
                onChange={(e) => setUsername(e.target.value)}
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("LoginComponent.email")} />

            <CssTextField size="small"
                value={pass}
                name="pass"
                type="password"
                onChange={(e) => setPass(e.target.value)}
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("LoginComponent.password")} />

            <Button variant="outlined" sx={{ width: {xs: '100%', md: 'initial'}}} onClick={handleLogin}>
                {t("LoginComponent.login")}
            </Button>
        </>
    );
}

export default LoginComponent;
